import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {loc} from "core/common/config/locales";

const gridLocation = 'taskList';

@observer
export default class TaskList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Tasks`;
  static icon = 'tasks';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("TaskList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gl => gridService.getOrCreateGrid(gridLocation));
  }


  render() {
    let {params, query} = this.props;

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}>
          {/*<ZzFlatButtonRoute onGridToolbar routeName="taskDetail" params={{id: 'new'}} label="New Task" permission={PERMISSION.New} securable={PAGE.taskDetail}/> */}
        </GridCompConnected>
    );
  }


}



// WEBPACK FOOTER //
// ./src/core/event/taskList.tsx